import React, { Dispatch, SetStateAction } from 'react';
// import defaultProfilePicture from '../../../images/default_profile_pic.png';
import PlaceHolder from "../../../images/avatar-placeholder.jpg";
import styles from './UserAvatar.module.css';

interface UserAvatarProps {
    showDropdown?: boolean;
    setShowDropDown?: Dispatch<SetStateAction<boolean>>;
    photoURL: string;
    isLoading?: boolean;
    onImageLoad?: () => void;
    /** When true, avatar is view-only (no dropdown, no click, no hover effects) */
    displayOnly?: boolean;
}

const UserAvatar = ({
    showDropdown = false,
    setShowDropDown,
    photoURL,
    isLoading = false,
    onImageLoad,
    displayOnly = false
}: UserAvatarProps) => {
    const displayImage = photoURL || PlaceHolder;

    return (
        <div className={`${styles.avatarContainer} ${!displayOnly && showDropdown ? styles.active : ''} ${displayOnly ? styles.displayOnly : ''}`}>
            {/* Shimmer Loading Effect */}
            {isLoading && (
                <div className={styles.shimmerOverlay}>
                    <div className={styles.shimmer}></div>
                </div>
            )}

            {/* Avatar with Border */}
            <div className={styles.avatarWrapper}>
                <img
                    src={displayImage}
                    alt="User Avatar"
                    onClick={displayOnly ? undefined : () => setShowDropDown?.(!showDropdown)}
                    onLoad={() => onImageLoad?.()}
                    className={`${styles.avatar} ${isLoading ? styles.loading : ''}`}
                />
            </div>
        </div>
    );
};

export default UserAvatar;
